/* eslint-disable react-hooks/exhaustive-deps */
// src/components/EventsGenresChart.js

import { useState, useEffect } from 'react';
import {
  PieChart, 
  Pie, 
  Cell,
  Legend,
  ResponsiveContainer
} from 'recharts';

const EventsGenreChart = ({ events }) => {
  const [data, setData] = useState([]);
  const genres = ['React', 'JavaScript', 'Node', 'jQuery', 'AngularJS'];
  const colors = ['#008B8B', '#FF7F50', '#00BFFF', '#9932CC', '#F08080'];

  useEffect(() => {
    setData(getData());
  }, [`${events}`]);

  const getData = () => {
    const data = genres.map(genre => {
        const filteredEvents = events.filter(event => event.summary.includes(genre)).length;
        return { 
            name: genre, 
            value: filteredEvents }
    })
    return data;
  };

  const renderCustomizedLabel = ({ 
    cx, 
    cy, 
    midAngle, 
    outerRadius, 
    percent, 
    index 
}) => {
    const RADIAN = Math.PI / 180;
    const radius = outerRadius;
    const x = cx + radius * Math.cos(-midAngle * RADIAN) * 1.07;
    const y = cy + radius * Math.sin(-midAngle * RADIAN) * 1.07;
    return percent ? (
      <text
        x={x}
        y={y}
        fill={colors[index]}
        textAnchor={x > cx ? 'start' : 'end'}
        dominantBaseline="central"
      >
        {`${genres[index]} ${(percent * 100).toFixed(0)}%`}
      </text>
    ) : null;
  };

  return (
    <ResponsiveContainer width="99%" height={400}>
      <PieChart>
        <Pie
            data={data}
            dataKey="value"
            fill="#8884d8"
            labelLine={false}
            label={renderCustomizedLabel}
            outerRadius={130}
        >
            {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
          ))}
        </Pie>
        <Legend verticalAlign="bottom" height={36}/>
      </PieChart>
    </ResponsiveContainer>
  );
}

export default EventsGenreChart;